// src/components/LocationGate.jsx
import React, { useEffect, useState } from "react";
import CountrySelector from "./CountrySelector"; // default export
import USLocationDialog from "./USLocationDialog"; // default export (ZIP-only)
import { useLocationCtx } from "../context/LocationContext";
import api from "../services/api";

export default function LocationGate({ forceOpen = false, lockOpen = false, onClose }) {
  const {
    country, setCountry,
    setUsZip,         // ΠΡΕΠΕΙ να υπάρχει στο Context
    setUsState,
    setStoreLocationId,
    setStoreLabel,
    countrySource,
    explicitUserSelectedCountry,
    refreshGuestState,
  } = useLocationCtx();

  const [openCountry, setOpenCountry] = useState(!!forceOpen);
  const [openUSZip, setOpenUSZip] = useState(false);

  useEffect(() => {
    setOpenCountry(!!forceOpen);
  }, [forceOpen]);

  useEffect(() => {
    if (process.env.REACT_APP_DEBUG_GUEST_STATE === "1") {
      console.info("[LocationGate] state", {
        country,
        countrySource,
        openCountry,
        openUSZip,
        forceOpen,
        lockOpen,
      });
    }
  }, [country, countrySource, openCountry, openUSZip, forceOpen, lockOpen]);

  const hasCountry = !!String(country || "").trim();
  const hasUserSelectedCountry = countrySource === "user" || explicitUserSelectedCountry;

  const logBlockedClose = (reason, source) => {
    if (process.env.REACT_APP_DEBUG_GUEST_STATE === "1") {
      console.info("[LocationGate] blocked close", {
        reason,
        source,
        lockOpen,
        hasCountry,
        hasUserSelectedCountry,
      });
    }
  };

  const handleCountryDialogClose = async (reason) => {
    if (lockOpen) {
      if (!hasCountry) {
        logBlockedClose(reason || "manual", "country");
        return;
      }
      if (!hasUserSelectedCountry) {
        if (reason === "ok") {
          // Mark explicit selection even if user picked the same country
          setCountry && setCountry(String(country), "user");
        } else {
          logBlockedClose(reason || "manual", "country");
          return;
        }
      }
    }
    await handleCountryClose();
  };

  const handleCountryClose = async () => {
    setOpenCountry(false);

    if (String(country) === "2") {
      // USA -> ρώτα μόνο ZIP
      setOpenUSZip(true);
    } else if (String(country) === "1") {
      // Greece -> καθάρισε US fields, σώσε και κλείσε
      setUsZip && setUsZip("");
      setUsState && setUsState("");
      setStoreLocationId && setStoreLocationId("");
      setStoreLabel && setStoreLabel("");

      try {
        await api.guest.mergeState({
          location: { country: "1", us_state: null, us_zip: null, store_location_id: null }
        });
        await refreshGuestState?.({ respectExplicitSelection: false });
      } catch {}

      onClose && onClose();
    } else {
      onClose && onClose();
    }
  };

  const handleZipCancel = (reason) => {
    if (lockOpen) {
      logBlockedClose(reason || "manual", "us_zip");
      setOpenUSZip(false);
      setOpenCountry(true);
      return;
    }
    // Επιστροφή στη χώρα, αν ακυρώσει
    setOpenUSZip(false);
    setOpenCountry(true);
  };

  const handleZipConfirm = async (zip) => {
    // Οριστικοποίηση US με ZIP μόνο
    setUsZip && setUsZip(zip);
    setUsState && setUsState("");
    setStoreLocationId && setStoreLocationId("");
    setStoreLabel && setStoreLabel("");

    try {
      await api.guest.mergeState({
        location: {
          country: "2",
          us_state: null,
          us_zip: zip,
          store_location_id: null
        }
      });
      await refreshGuestState?.({ respectExplicitSelection: false });
    } catch {}

    setOpenUSZip(false);
    onClose && onClose();
  };

  return (
    <>
      <CountrySelector
        open={openCountry}
        country={country || ""}
        setCountry={(v) => setCountry && setCountry(v, "user")}
        lockOpen={lockOpen}
        onClose={handleCountryDialogClose}
      />

      <USLocationDialog
        open={openUSZip}
        lockOpen={lockOpen}
        onCancel={handleZipCancel}
        onConfirm={handleZipConfirm}
      />
    </>
  );
}
